<template>
    <vue-autosuggest
        class="filter"
        ref="autocomplete"
        :suggestions="suggestions"
        :input-props="inputProps"
        :render-suggestion="renderSuggestion"
        :get-suggestion-value="getSuggestionValue"
        @selected="onSuggestionSelect"
        @input="fetchResults"
    />
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'

export default {
    components: {
        VueAutosuggest
    },
    props: {
        searchRequestor: {
            required: true
        },
        renderSuggestion: {
            default() {
                return (suggestion) => suggestion.item.title || 'Define you suggestion renderer'
            }
        },
        getSuggestionValue: {
            default() {
                return (suggestion) => suggestion.item.title || 'Define you suggestion value provider'
            }
        }
    },
    data() {
        return {
            suggestions: [],
            inputProps: {
                id: 'autosuggest__input_ajax',
                placeholder: this.$t('Component(AutoSuggest):search-placeholder'),
                class: 'form-control w-100',
                name: 'ajax',
            },
        }
    },
    methods: {
        onSuggestionSelect(suggestion) {
            this.$emit('selected', suggestion.item);
        },
        fetchResults(qs) {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                this.searchRequestor(qs).then(r => {
                    this.suggestions = [{data: r.data}];
                });
            }, 600);
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.filter .autosuggest__results {
    width: inherit;
}

.autosuggest__results-item {
    cursor: pointer;
}
</style>
